import React from 'react';
import {useLocation, useParams} from 'react-router-dom';
import {Observer} from "mobx-react-lite";
import DescriptionIcon from '@mui/icons-material/Description';
import TabOption from "../../ui_components/Tab/TabOption";
import Tabs from "../../ui_components/Tab/Tabs";
import {useI18nContext} from "../../contexts/I18nContext";
import DocumentSettingsTab from "../Configurations/tabs/DocumentSettings/DocumentSettingsTab";
import {useStyles} from "../Configurations/Configurations.style";

/**
 * Per-agency configuration, opened from the agency list. New configuration areas become extra
 * tabs here instead of new pages.
 */
const AgencyConfigurations: React.FC = () => {
    const classes = useStyles();
    const i18n = useI18nContext();
    const {id: paramId} = useParams();
    const location = useLocation();
    // Routes declared in RouteRepository are wrapped in <AllowAccess>, and react-router
    // 6.0.0-beta.0 does not bind the path params through that wrapper, so useParams() comes back
    // empty here. The agency id is read from the path, with useParams kept as the primary source.
    const id = paramId || location.pathname.split('/').filter(Boolean).pop();

    return (
        <Observer>{() => {
            const tabsContent = [
                new TabOption(
                    i18n.translate("DOCUMENT_SETTINGS"),
                    <DocumentSettingsTab agencyId={id}/>,
                    <DescriptionIcon/>
                ),
            ];
            return (
                <div className={classes.dashboard_container}>
                    <div className={classes.box_container}>
                        <Tabs content={tabsContent} orientation='vertical' className={classes.tab_container_custom}/>
                    </div>
                </div>
            )
        }}
        </Observer>
    )
}

export default AgencyConfigurations;
